import { Box, Typography, useTheme } from '@mui/material';
import ExpandableBox from 'src/components/common/ExpandableBox';
import TableHorizontal from 'src/components/TableHorizontal';

const ExchangeRate = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const {
    palette: { background },
    shape,
  } = useTheme();
  return (
    <ExpandableBox title="Exchange Rate" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={background.default}
        borderRadius={`0px 0px ${shape.borderRadius * 2}px ${shape.borderRadius * 2}px`}
      >
        <TableHorizontal
          colKeyWidth={350}
          configColumn={[
            {
              label: 'Currency Transaction',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    {data.transaction?.exchange_currency}
                  </Typography>
                );
              },
            },
            {
              label: 'Exchange Rate',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    {data.transaction?.exchange_rate}
                  </Typography>
                );
              },
            },
            {
              label: 'Exchange Date',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    {data.transaction?.exchange_date}
                  </Typography>
                );
              },
            },
          ]}
          data={tradeDataDetail}
        />
      </Box>
    </ExpandableBox>
  );
};

export default ExchangeRate;
